import {
  WorkOrderServiceCategory,
  WorkOrderServiceItem,
} from '@backoffice-frontend/graphql'
import { Option } from '@moia-dev/pace-web'
import {
  useWorkOrderServiceCategoryTranslation,
  useWorkOrderServiceItemTranslation,
} from '../hooks/useWorkOrderTranslations'

export type WorkOrderServiceItemCategoryMapping = {
  title: WorkOrderServiceCategory
  serviceItems: WorkOrderServiceItem[]
}

const workOrderServiceItemCategoryMappings: WorkOrderServiceItemCategoryMapping[] =
  [
    {
      title: WorkOrderServiceCategory.MaintenanceService,
      serviceItems: [
        WorkOrderServiceItem.MainInspection,
        WorkOrderServiceItem.MileageInspection,
        WorkOrderServiceItem.Maintenance,
        WorkOrderServiceItem.InternalInspection,
        WorkOrderServiceItem.BrakeFluidChange,
      ],
    },
    {
      title: WorkOrderServiceCategory.DamagesDefects,
      serviceItems: [
        WorkOrderServiceItem.SeatComplaint,
        WorkOrderServiceItem.SmartRepairDent,
        WorkOrderServiceItem.SmartRepairPaintwork,
      ],
    },
    {
      title: WorkOrderServiceCategory.Ivc,
      serviceItems: [WorkOrderServiceItem.TabletUpdate],
    },
    {
      title: WorkOrderServiceCategory.HubActivities,
      serviceItems: [
        WorkOrderServiceItem.VehicleLettering,
        WorkOrderServiceItem.InsideCleaning,
        WorkOrderServiceItem.OutsideCleaning,
        WorkOrderServiceItem.Charging,
        WorkOrderServiceItem.TransferRide,
      ],
    },
    {
      title: WorkOrderServiceCategory.Incident,
      serviceItems: [WorkOrderServiceItem.InFieldSupport],
    },
    {
      title: WorkOrderServiceCategory.Other,
      serviceItems: [WorkOrderServiceItem.Other],
    },
  ]

export const workOrderServiceItemOptions = () => {
  return workOrderServiceItemCategoryMappings.flatMap(category => [
    <Option key={category.title} disabled={true} value={''}>
      {useWorkOrderServiceCategoryTranslation()(category.title)}
    </Option>,
    ...category.serviceItems.map(item => (
      <Option key={item} value={item}>
        {useWorkOrderServiceItemTranslation()(item)}
      </Option>
    )),
  ])
}
